export enum YesNoType {
  NO = 'no',
  YES = 'yes',
}
